import React from 'react';
import './styles/home.css';
import { Link } from "react-router-dom";

const ActivitiesHome = () => {
    return (
        <div id='activities-home-main'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
                <img className='activities-icon' src={process.env.PUBLIC_URL + 'images/activities-icon-gold.png'}></img>
                <h2>ACTIVITIES</h2>
            </div>


            <div id='activity-cards-home'>
                <div className='activity-card-home'>
                    <div className='activity-image-bg'>
                        <div className='activity-card-home-img' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/coloring-book.jpg)` }} >
                        </div>
                    </div>
                    <div className='activity-card-line'></div>
                    <div className='activity-card-content-home'>

                        <h3 className='coloring-book-h'>Coloring Book</h3>

                        <p>Urgent: You, the Design Maestro The show choir director is in full-on crisis mode and has turned to you for help. The program book artwork is due today, and while several designs are ready, there’s one glaring problem—the director forgot to hire a colorist! Fully realized graphics are needed in just three hours, and your expertise is the key to saving the day.

                            You’ve been chosen because of your talent, precision, and speed. The clock is ticking—can you rise to the challenge and deliver brilliance under pressure?</p>

                        <Link to='/coloringbookoptions' style={{ textDecoration: 'none', width: '100%' }}>
                            <button className='activity-btn-home gold-gradient-wshimmer'>Start Coloring</button>
                        </Link>

                    </div>


                </div>

                <div className='activity-card-home'>
                    <div className='activity-image-bg'>
                        <div className='activity-card-home-img' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scavenger-hunt.png)` }} >
                        </div>
                    </div>
                    <div className='activity-card-line'></div>
                    <div className='activity-card-content-home'>

                        <h3 className='coloring-book-h'>Scavenger Hunt</h3>

                        <p>
                            Ready for a fun-filled adventure? Dive into our show choir scavenger hunt—no stress, just pure excitement! Search for all the hidden items on your own, or turn it into a friendly competition with the person next to you. Who will uncover them all first? Let the hunt begin! Game on!</p>

                        <Link to='/scavengerhunt' style={{ textDecoration: 'none', width: '100%' }}>
                            <button className='activity-btn-home gold-gradient-wshimmer'>Start Searching</button>
                        </Link>

                    </div>


                </div>
            </div>





        </div>
    )
}

export default ActivitiesHome
